module.exports = __webpack_public_path__ + "img/icon_chenggong.ddb45b70.png";